import styled from 'styled-components';
import { colors } from '../../../utils/utils';

const Indicator = styled.div<{ $good?: boolean }>`
    font-size: 13px;
    font-weight: bold;
    text-align: center;

    color: ${props => (props.$good ? colors.green.medium_aquamarine : colors.red.radical_red)};
`;

export default Indicator;
